export default __webpack_public_path__ + "static/media/BookIcon.815c3874.svg";